import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import SpeakerNotesOffOutlined from '@mui/icons-material/SpeakerNotesOffOutlined';
import { Link } from 'react-router-dom';
import { useL10n } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';
import { usePatientNextAppointmentsQuery, useUserMatchesQuery } from '@uplift/queries';
import { ProviderMedicalRole } from '@uplift/types';
import { useCurrentuser } from '@uplift/contexts';
import { ROUTING_CONFIG } from '@uplift/constants';


const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(5, 2),
    display: 'flex',
    justifyContent: 'center'
  },
  content: {
    maxWidth: '342px',
    textAlign: 'center'
  },
  icon: {
    fontSize: '60px',
    color: theme.palette.legacyPrimary.light,
  }
}));


export const NoSessionsHistory: React.VFC = () => {
  const me = useCurrentuser();
  const l10n = useL10n();
  const { classes } = useStyles();
  const { data: nextSession } = usePatientNextAppointmentsQuery({ limit: 1 }, { suspense: true });
  const { data: matches } = useUserMatchesQuery(me.id, undefined, { suspense: true });
  const therapistsCount = matches?.activeMatches?.filter(m => m.provider.medicalRole === ProviderMedicalRole.therapist)?.length;
  const noTherapists = therapistsCount === 0;
  const hasSessionsInTheFuture = nextSession?.length === 1;

  const subtitle = React.useMemo(() => {
    if (hasSessionsInTheFuture) {
      return null;
    }

    if (noTherapists) {
      return (
        <Box mt={5}>
          <Button component={Link} to={ROUTING_CONFIG.matching} variant="contained" color="secondary">{l10n.sessionHistory.noSessionHistory.findATherapist}</Button>
        </Box>
      );
    }

    return (
      <Box mt={2}>
        <Typography variant="body1" color="textPrimary">{l10n.sessionHistory.noSessionHistory.subtitle}</Typography>
      </Box>
    );
  }, [ noTherapists, hasSessionsInTheFuture, l10n ]);

  return (
    <Paper elevation={1}>
      <Box className={classes.root}>
        <Box className={classes.content}>
          <SpeakerNotesOffOutlined className={classes.icon} />
          <Box mt={2}>
            <Typography variant="h6" color="textPrimary">{l10n.sessionHistory.noSessionHistory.title}</Typography>
          </Box>
          {subtitle}
        </Box>
      </Box>
    </Paper>
  );
};
